<div class="container d-flex justify-content-center align-items-center">
  @if(loading){
  <div class="card shadow-sm border-0 text-center p-5" style="max-width: 520px; border-radius: 20px;">
    <div class="mb-4">
      <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <h3 class="fw-semibold mb-3 text-dark">Verifying...</h3>
    <p class="text-muted mb-0">
      Please wait while we confirm your email address.
    </p>
  </div>
  } @else {
  @if(verified){
  <div class="card shadow-sm border-0 text-center p-5" style="max-width: 520px; border-radius: 20px;">
    <div class="mb-4">
      <i class="bi bi-check-circle-fill text-success" style="font-size: 4rem;"></i>
    </div>
    <h3 class="fw-semibold mb-3 text-dark">Email Verified Successfully</h3>
    <p class="text-muted mb-2">
      Our team will perform a background check based on the information you provided.
    </p>
    <p class="text-muted mb-2">
      If there are any discrepancies, we’ll reach out to you within the next <strong>12 hours</strong>.
    </p>
    <p class="text-muted mb-4">
      Once vetted, you’ll receive a confirmation from us — after which you can log in!
    </p>
  </div>
  }@else {
  <div class="card shadow-sm border-0 text-center p-5" style="max-width: 520px; border-radius: 20px;">
    <div class="mb-4">
      <i class="bi bi-x-circle-fill text-danger" style="font-size: 4rem;"></i>
    </div>
    <h3 class="fw-semibold mb-3 text-dark">Email Verification Failed</h3>
    <p class="text-muted mb-2">
      Our team will reach out to you within the next <strong>12 hours</strong>.
    </p>
  </div>
  }
  }
</div>